// extracted by mini-css-extract-plugin
export default {"icon":"ClearFilterButton_icon__H0oFc"};